import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CmsProvider } from "@/context/CmsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import DashboardLayout from "@/components/DashboardLayout";
import Accueil from "@/pages/Accueil";
import APropos from "@/pages/APropos";
import Accompagnements from "@/pages/Accompagnements";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import MotDePasseOublie from "@/pages/MotDePasseOublie";
import Clients from "@/pages/dashboard/Clients";
import ClientDetail from "@/pages/dashboard/ClientDetail";
import Calendrier from "@/pages/dashboard/Calendrier";
import Contenus from "@/pages/dashboard/Contenus";
import ClientLayout from "@/pages/client/ClientLayout";
import MesInfos from "@/pages/client/MesInfos";
import MesDocuments from "@/pages/client/MesDocuments";
import MesRdv from "@/pages/client/MesRdv";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <AuthProvider>
                    <CmsProvider>
                        <Routes>
                            <Route path="/" element={<Accueil />} />
                            <Route path="/a-propos" element={<APropos />} />
                            <Route path="/accompagnements" element={<Accompagnements />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />

                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute roles={["consultant"]}>
                                        <DashboardLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<Clients />} />
                                <Route path="clients/:id" element={<ClientDetail />} />
                                <Route path="calendrier" element={<Calendrier />} />
                                <Route path="contenus" element={<Contenus />} />
                            </Route>

                            <Route
                                path="/espace-client"
                                element={
                                    <ProtectedRoute roles={["client"]}>
                                        <ClientLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<MesInfos />} />
                                <Route path="documents" element={<MesDocuments />} />
                                <Route path="rendez-vous" element={<MesRdv />} />
                            </Route>
                        </Routes>
                    </CmsProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
